import { exceptionName, makeError } from './exception';

// 'AbortError' is the name of default Error reason when
// aborting an AbortController, so we use that name so that such
// errors pass isAbortError.
export const ABORT_ERROR = 'AbortError';
export function isAbortError(err: unknown) {
  return exceptionName(err) === ABORT_ERROR;
}

export function isCanceledError(err: unknown) {
  const message = err instanceof Error ? err.message : String(err);
  const lowerMessage = message.toLowerCase();
  return lowerMessage.includes('cancel') || lowerMessage === 'canceled';
}

export function abortable<T>(func: () => Promise<T>, abortController: AbortController) {
  return new Promise<T>((resolve, reject) => {
    abortController.signal.addEventListener('abort', () => {
      reject(makeError('Aborted', ABORT_ERROR, {
        cause: abortController.signal.reason,
      }));
    });
    func()
      .then(result => {
        resolve(result);
      })
      .catch(err => reject(err));
  });
}
